module.exports = __webpack_public_path__ + "img/footer06.fa520173.png";